import { render, staticRenderFns } from "./ev5-videopicstext-swiper.vue?vue&type=template&id=1e798865&scoped=true"
import script from "./ev5-videopicstext-swiper.vue?vue&type=script&lang=js"
export * from "./ev5-videopicstext-swiper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e798865",
  null
  
)

export default component.exports